<div
	class="sh-switch-organization-dialog-container"
	id="sh-switch-organization-dialog-container-div"
	data-testid="switch-organization-dialog"
	*transloco="let t; prefix: 'scSwitchOrganization'"
>
	<prism-dialog id="sh-switch-organization-content-div" confirm-button="" cancel-button="" visible="true">
		<h1
			slot="dialog-title"
			[class]="dialogTitleClass ?? ''"
			id="sh-switch-organization-title-h1"
			data-testid="switch-organization-dialog-title"
		>
			{{ dialogTitle ?? t('switch-organization-dialog.change-organization') }}
		</h1>

		<div class="sh-switch-organization-subtitle" id="sh-switch-organization-title-div">
			{{ t('switch-organization-dialog.select-organization-from-list') }}
		</div>
		<div class="sh-switch-organization-content">
			<div class="sh-switch-organization-search-container" id="sh-switch-organization-search-container-div">
				<prism-search-bar
					class="sh-switch-organization-search-bar"
					id="sh-switch-organization-search-bar"
					(valueInput)="applyFilter($event.detail)"
					(valueChange)="applyFilter($event.detail)"
					[placeholder]="t('search-bar.placeholder')"
					[clearTooltipText]="t('search-bar.clear-tooltip')"
				></prism-search-bar>
				@if (showCreateButton()) {
					<prism-button
						variant="bright"
						class="sh-switch-organization-create-button"
						id="sh-switch-organization-create-button-div"
						(click)="openCreateOrganization()"
					>
						{{ t('switch-organization-dialog.create-organization') }}
						<prism-icon icon="add" slot="icon-start" size="sm"></prism-icon>
					</prism-button>
				}
			</div>

			@if (!loading()) {
				@if (filteredOrganizations().length > 0) {
					<prism-list class="sh-switch-organization-list" id="sh-switch-organization-list">
						@for (org of filteredOrganizations(); track org.id) {
							<prism-list-item
								class="sh-switch-organization-item"
								id="sh-switch-organization-organization-item-{{ org.id }}"
								[attr.data-testid]="'organization-item-' + org.id"
								[class.sh-switch-organization-selected]="selectedOrg()?.id === org.id"
								(click)="selectOrganization(org)"
							>
								<div
									class="sh-switch-organization-details"
									id="sh-switch-organization-details-div-{{ org.id }}"
								>
									<div
										class="sh-switch-organization-icon-container"
										id="sh-switch-organization-icon-container-div-{{ org.id }}"
										[style.background-color]="org.profileColor"
									>
										<div
											class="sh-switch-organization-org-icon"
											id="sh-switch-organization-org-icon-div-{{ org.id }}"
											data-testid="organization-initials"
										>
											{{ org.initials }}
										</div>
									</div>
									<div
										class="sh-switch-organization-name-container"
										id="sh-switch-organization-organization-name-div-{{ org.id }}"
									>
										<div id="sh-switch-organization-name-details-{{ org.id }}">
											<h4
												class="sh-switch-organization-name"
												id="sh-switch-organization-organization-name-h4-{{ org.id }}"
											>
												{{ org.name }}
												@if (currentOrgId.value() === org.id) {
													{{ t('switch-organization-dialog.current-label') }}
												}
											</h4>
											<p
												class="sh-switch-organization-company"
												id="sh-switch-organization-company-name-p-{{ org.id }}"
											>
												{{ org.companyName }}
											</p>
										</div>
										<div id="sh-switch-organization-icon-content-{{ org.id }}">
											@if (org.verificationStatus === verificationStatus.VERIFIED) {
												<prism-icon
													icon="verified"
													id="sh-switch-organization-verify-icon-{{ org.id }}"
													data-testid="organization-verified-icon"
													size="md"
													class="sh-switch-organization-verify-icon"
												></prism-icon>
											}
										</div>
									</div>
								</div>
							</prism-list-item>
						}
					</prism-list>
				} @else {
					<div
						class="sh-switch-organization-list sh-switch-organization-no-rows"
						id="sh-switch-organization-no-rows-div"
					>
						<p id="sh-switch-organization-no-organizations-p">
							{{ t('switch-organization-dialog.no-organizations-found') }}
						</p>
						<p id="sh-switch-organization-different-search-text-p">
							{{ t('switch-organization-dialog.try-different-search') }}
						</p>
					</div>
				}
			} @else if (isOffline()) {
				<div
					class="sh-switch-organization-list sh-switch-organization-no-rows"
					id="sh-switch-organization-offline-div"
				>
					<p id="sh-switch-organization-no-internet-p">
						{{ t('switch-organization-dialog.no-internet-connection') }}
					</p>
				</div>
			} @else {
				<div class="sh-switch-organization-loader" id="sh-switch-organization-loader-div">
					<prism-progress-indicator size="md" type="indeterminate"></prism-progress-indicator>
				</div>
			}
		</div>
		<div class="sh-switch-organization-action-buttons" id="sh-switch-organization-action-buttons-div">
			<prism-button variant="standard" id="sh-switch-organization-cancel-button" (click)="closeDialog()">{{
				t('switch-organization-dialog.cancel')
			}}</prism-button>
			<prism-button
				[disabled]="!selectedOrg() || !selectedOrg()?.id"
				variant="standard"
				id="sh-switch-organization-switch-org-button"
				(click)="confirmSwitch()"
			>
				{{ dialogConfirmButtonLabel ?? t('switch-organization-dialog.change-organization') }}
			</prism-button>
		</div>
	</prism-dialog>
</div>
